import { render, staticRenderFns } from "./erpnavtop.vue?vue&type=template&id=352e89d7&scoped=true"
import script from "./erpnavtop.vue?vue&type=script&lang=js"
export * from "./erpnavtop.vue?vue&type=script&lang=js"
import style0 from "./erpnavtop.vue?vue&type=style&index=0&id=352e89d7&scoped=true&lang=scss"
import style1 from "./erpnavtop.vue?vue&type=style&index=1&id=352e89d7&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352e89d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352e89d7')) {
      api.createRecord('352e89d7', component.options)
    } else {
      api.reload('352e89d7', component.options)
    }
    module.hot.accept("./erpnavtop.vue?vue&type=template&id=352e89d7&scoped=true", function () {
      api.rerender('352e89d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/erpnavtop.vue"
export default component.exports